import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved ? saved === 'dark' : true; // Default to dark
  });

  useEffect(() => {
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
    
    // Update CSS variables based on theme
    const root = document.documentElement;
    
    if (isDark) {
      // Dark theme
      root.style.setProperty('--bg-dark', '#0A0A0F');
      root.style.setProperty('--bg-card', '#12121A');
      root.style.setProperty('--bg-elevated', '#1A1A25');
      root.style.setProperty('--text-primary', '#FFFFFF');
      root.style.setProperty('--text-secondary', 'rgba(255, 255, 255, 0.75)');
      root.style.setProperty('--text-muted', 'rgba(255, 255, 255, 0.5)');
      root.style.setProperty('--border', 'rgba(255, 255, 255, 0.1)');
      root.style.setProperty('--border-hover', 'rgba(255, 255, 255, 0.2)');
      document.body.style.background = '#0A0A0F';
      document.body.style.color = '#FFFFFF';
    } else {
      // Light theme
      root.style.setProperty('--bg-dark', '#F8FAFC');
      root.style.setProperty('--bg-card', '#FFFFFF');
      root.style.setProperty('--bg-elevated', '#F1F5F9');
      root.style.setProperty('--text-primary', '#0F172A');
      root.style.setProperty('--text-secondary', 'rgba(15, 23, 42, 0.75)');
      root.style.setProperty('--text-muted', 'rgba(15, 23, 42, 0.5)');
      root.style.setProperty('--border', 'rgba(15, 23, 42, 0.1)');
      root.style.setProperty('--border-hover', 'rgba(15, 23, 42, 0.2)');
      document.body.style.background = '#F8FAFC';
      document.body.style.color = '#0F172A';
    }
  }, [isDark]);

  const toggleTheme = () => {
    setIsDark(prev => !prev);
  };

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
